import React from "react";
import {
  TextField,
  Button,
  DialogContent,
  DialogActions,
  InputAdornment,
} from "@mui/material";

const VerificationStep = ({
  mobileNumber,
  setMobileNumber,
  otp,
  setOtp,
  handleVerify,
  handleOtpSubmit,
  handleBack,
}) => {
  return (
    <>
      <DialogContent sx={{ overflowX: "hidden" }}>
        <TextField
          label="Mobile Number"
          value={mobileNumber}
          onChange={(e) => setMobileNumber(e.target.value)}
          fullWidth
          sx={{ mb: 2 }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Button onClick={handleVerify} variant="text" >
                  Verify
                </Button>
              </InputAdornment>
            ),
          }}
        />
        <TextField
          label="Enter OTP"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
          fullWidth
          sx={{ mb: 2 }}
          inputProps={{ maxLength: 6 }}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleBack}
          variant="text"
          sx={{ height: "100%", ml: 2 }}
        >
          Back
        </Button>
        <Button
          onClick={handleOtpSubmit}
          variant="contained"
          sx={{
            height: "100%",
            background: "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
            color: "#fff",
            borderRadius: "8px",
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
            textTransform: "uppercase",
            fontWeight: "bold",
            "&:hover": {
              background: "linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)",
              boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.3)",
            },
          }}
        >
          Verify OTP
        </Button>
      </DialogActions>
    </>
  );
};

export default VerificationStep;
